/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.crontask.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from './app.config.service';
import {Observable} from 'rxjs';

/**
 * Zweck: Beschreibt class AppCrontaskService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppCrontaskService {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient, private cfg: AppConfigService) {
  }

/**
 * Beschreibt Methode getnextTimeWKImportAutosendTask und ihren Rückgabevertrag.
 */
  getnextTimeWKImportAutosendTask(): Observable<string> {
    return this.http.get<string>(
      '/tasks/nexttime/WKImportAutosend'
    );
  }
}
